import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum TaskStatusEnum {
    NotYetDue = 200,
    NotYetStarted = 205,
    Saved = 210,
    SubmittedPendingCoSignature = 211,
    CompletedPendingQAReview = 215,
    CompletedExportReady = 220,
    Exported = 225,
    ReturnedForReview = 230,
    Reopened = 235,
    CompletedNotExported = 240,
    NonOasisCompleted = 245,
    MissedVisit = 400,
    MissedVisitPending = 401,
    MissedVisitComplete = 402,
    MissedVisitReturnForReview = 403,
    NoteNotStarted = 405,
    NoteNotYetDue = 410,
    NoteSaved = 415,
    NotePendingCoSignature = 418,
    NoteSubmittedCoSignature = 419,
    NoteSubmittedWithSignature = 420,
    SubmittedWithSignaturePendingOasisApproval = 421,
    NoteCompleted = 425,
    CompletedPendingOasisApproval = 426,
    NoteReturned = 430,
    NoteReopened = 435,
    AwaitingClinicianSignature = 440,
    PendingAssessmentApproval = 441,
    EvalSubmittedPendingCoSignature = 444,
    EvalToBeSentToPhysician = 445,
    EvalSentToPhysician = 450,
    EvalReturnedWPhysicianSignature = 455,
    EvalSentToPhysicianElectronically = 460,
    NoteReturnedForClinicianSignature = 465,
    EvalReturnedByPhysician = 470,
    NoteSavedFromMobile = 475,
    NoteCompletedFromMobile = 480,
    NoteSubmittedFromMobile = 485
}

export class HCTaskStatusEnumClass extends EnumWithDescription<TaskStatusEnum> {
    public readonly enum = TaskStatusEnum;
    public readonly enumName: string = "HCTaskStatusEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<TaskStatusEnum>> = new Map([
        [
            "NotYetDue",
            {
                value: TaskStatusEnum.NotYetDue,
                name: "Not Yet Due"
            }
        ],
        [
            "NotYetStarted",
            {
                value: TaskStatusEnum.NotYetStarted,
                name: "Not Yet Started"
            }
        ],
        [
            "Saved",
            {
                value: TaskStatusEnum.Saved,
                name: "Saved"
            }
        ],
        [
            "SubmittedPendingCoSignature",
            {
                value: TaskStatusEnum.SubmittedPendingCoSignature,
                name: "Submitted Pending Co-Signature"
            }
        ],
        [
            "CompletedPendingQAReview",
            {
                value: TaskStatusEnum.CompletedPendingQAReview,
                name: "Completed (Pending QA Review)"
            }
        ],
        [
            "CompletedExportReady",
            {
                value: TaskStatusEnum.CompletedExportReady,
                name: "Completed (Export Ready)"
            }
        ],
        [
            "Exported",
            {
                value: TaskStatusEnum.Exported,
                name: "Exported"
            }
        ],
        [
            "ReturnedForReview",
            {
                value: TaskStatusEnum.ReturnedForReview,
                name: "Returned For Review"
            }
        ],
        [
            "Reopened",
            {
                value: TaskStatusEnum.Reopened,
                name: "Reopened"
            }
        ],
        [
            "CompletedNotExported",
            {
                value: TaskStatusEnum.CompletedNotExported,
                name: "Completed (Not Exported)"
            }
        ],
        [
            "MissedVisit",
            {
                value: TaskStatusEnum.MissedVisit,
                name: "Missed Visit"
            }
        ],
        [
            "MissedVisitPending",
            {
                value: TaskStatusEnum.MissedVisitPending,
                name: "Missed Visit(Pending)"
            }
        ],
        [
            "MissedVisitComplete",
            {
                value: TaskStatusEnum.MissedVisitComplete,
                name: "Missed Visit(Complete)"
            }
        ],
        [
            "MissedVisitReturnForReview",
            {
                value: TaskStatusEnum.MissedVisitReturnForReview,
                name: "Missed Visit(Return for Review)"
            }
        ],
        [
            "NoteNotStarted",
            {
                value: TaskStatusEnum.NoteNotStarted,
                name: "Not Yet Started"
            }
        ],
        [
            "NoteNotYetDue",
            {
                value: TaskStatusEnum.NoteNotYetDue,
                name: "Not Yet Due"
            }
        ],
        [
            "NoteSaved",
            {
                value: TaskStatusEnum.NoteSaved,
                name: "Saved"
            }
        ],
        [
            "NoteSubmittedCoSignature",
            {
                value: TaskStatusEnum.NoteSubmittedCoSignature,
                name: "Submitted Pending Co-Signature"
            }
        ],
        [
            "NoteSubmittedWithSignature",
            {
                value: TaskStatusEnum.NoteSubmittedWithSignature,
                name: "Submitted With Signature"
            }
        ],
        [
            "NoteCompleted",
            {
                value: TaskStatusEnum.NoteCompleted,
                name: "Completed"
            }
        ],
        [
            "NoteReturned",
            {
                value: TaskStatusEnum.NoteReturned,
                name: "Returned For Review"
            }
        ],
        [
            "NoteReopened",
            {
                value: TaskStatusEnum.NoteReopened,
                name: "Reopened"
            }
        ],
        [
            "EvalSubmittedPendingCoSignature",
            {
                value: TaskStatusEnum.EvalSubmittedPendingCoSignature,
                name: "Submitted Pending Co-Signature"
            }
        ],
        [
            "EvalToBeSentToPhysician",
            {
                value: TaskStatusEnum.EvalToBeSentToPhysician,
                name: "To Be Sent To Physician"
            }
        ],
        [
            "EvalSentToPhysician",
            {
                value: TaskStatusEnum.EvalSentToPhysician,
                name: "Sent To Physician (Fax, Mail, etc)"
            }
        ],
        [
            "EvalReturnedWPhysicianSignature",
            {
                value: TaskStatusEnum.EvalReturnedWPhysicianSignature,
                name: "Returned W/ Physician Signature"
            }
        ],
        [
            "EvalSentToPhysicianElectronically",
            {
                value: TaskStatusEnum.EvalSentToPhysicianElectronically,
                name: "Sent To Physician (Electronically)"
            }
        ],
        [
            "NoteReturnedForClinicianSignature",
            {
                value: TaskStatusEnum.NoteReturnedForClinicianSignature,
                name: "Returned for Clinician Signature"
            }
        ],
        [
            "EvalReturnedByPhysician",
            {
                value: TaskStatusEnum.EvalReturnedByPhysician,
                name: "Returned for Review by Physician"
            }
        ]
    ]);
}

export class HHTaskStatusEnumClass extends EnumWithDescription<TaskStatusEnum> {
    public readonly enum = TaskStatusEnum;
    public readonly enumName: string = "HHTaskStatusEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<TaskStatusEnum>> = new Map([
        [
            "NotYetDue",
            {
                value: TaskStatusEnum.NotYetDue,
                name: "Not Yet Due"
            }
        ],
        [
            "NotYetStarted",
            {
                value: TaskStatusEnum.NotYetStarted,
                name: "Not Yet Started"
            }
        ],
        [
            "Saved",
            {
                value: TaskStatusEnum.Saved,
                name: "Saved"
            }
        ],
        [
            "SubmittedPendingCoSignature",
            {
                value: TaskStatusEnum.SubmittedPendingCoSignature,
                name: "Submitted Pending Co-Signature"
            }
        ],
        [
            "CompletedPendingQAReview",
            {
                value: TaskStatusEnum.CompletedPendingQAReview,
                name: "Completed (Pending QA Review)"
            }
        ],
        [
            "CompletedExportReady",
            {
                value: TaskStatusEnum.CompletedExportReady,
                name: "Completed (Export Ready)"
            }
        ],
        [
            "Exported",
            {
                value: TaskStatusEnum.Exported,
                name: "Exported"
            }
        ],
        [
            "ReturnedForReview",
            {
                value: TaskStatusEnum.ReturnedForReview,
                name: "Returned For Review"
            }
        ],
        [
            "Reopened",
            {
                value: TaskStatusEnum.Reopened,
                name: "Reopened"
            }
        ],
        [
            "CompletedNotExported",
            {
                value: TaskStatusEnum.CompletedNotExported,
                name: "Completed (Not Exported)"
            }
        ],
        [
            "NonOasisCompleted",
            {
                value: TaskStatusEnum.NonOasisCompleted,
                name: "Completed"
            }
        ],
        [
            "MissedVisit",
            {
                value: TaskStatusEnum.MissedVisit,
                name: "Missed Visit"
            }
        ],
        [
            "MissedVisitPending",
            {
                value: TaskStatusEnum.MissedVisitPending,
                name: "Missed Visit (Pending QA Review)"
            }
        ],
        [
            "MissedVisitComplete",
            {
                value: TaskStatusEnum.MissedVisitComplete,
                name: "Missed Visit (Complete)"
            }
        ],
        [
            "MissedVisitReturnForReview",
            {
                value: TaskStatusEnum.MissedVisitReturnForReview,
                name: "Missed Visit (Returned For Review)"
            }
        ],
        [
            "NoteNotStarted",
            {
                value: TaskStatusEnum.NoteNotStarted,
                name: "Not Yet Started"
            }
        ],
        [
            "NoteNotYetDue",
            {
                value: TaskStatusEnum.NoteNotYetDue,
                name: "Not Yet Due"
            }
        ],
        [
            "NoteSaved",
            {
                value: TaskStatusEnum.NoteSaved,
                name: "Saved"
            }
        ],
        [
            "NotePendingCoSignature",
            {
                value: TaskStatusEnum.NotePendingCoSignature,
                name: "Submitted (Pending Co-Signature)"
            }
        ],
        [
            "NoteSubmittedWithSignature",
            {
                value: TaskStatusEnum.NoteSubmittedWithSignature,
                name: "Submitted With Signature"
            }
        ],
        [
            "SubmittedWithSignaturePendingOasisApproval",
            {
                value: TaskStatusEnum.SubmittedWithSignaturePendingOasisApproval,
                name: "Pending OASIS Approval"
            }
        ],
        [
            "NoteCompleted",
            {
                value: TaskStatusEnum.NoteCompleted,
                name: "Completed"
            }
        ],
        [
            "CompletedPendingOasisApproval",
            {
                value: TaskStatusEnum.CompletedPendingOasisApproval,
                name: "Pending OASIS Approval"
            }
        ],
        [
            "NoteReturned",
            {
                value: TaskStatusEnum.NoteReturned,
                name: "Returned For Review"
            }
        ],
        [
            "NoteReopened",
            {
                value: TaskStatusEnum.NoteReopened,
                name: "Reopened"
            }
        ],
        [
            "AwaitingClinicianSignature",
            {
                value: TaskStatusEnum.AwaitingClinicianSignature,
                name: "Awaiting Clinician Signature"
            }
        ],
        [
            "PendingAssessmentApproval",
            {
                value: TaskStatusEnum.PendingAssessmentApproval,
                name: "Pending Approval of Assessment"
            }
        ],
        [
            "EvalToBeSentToPhysician",
            {
                value: TaskStatusEnum.EvalToBeSentToPhysician,
                name: "To Be Sent To Physician"
            }
        ],
        [
            "EvalSentToPhysician",
            {
                value: TaskStatusEnum.EvalSentToPhysician,
                name: "Sent To Physician (Fax, Mail, etc)"
            }
        ],
        [
            "EvalReturnedWPhysicianSignature",
            {
                value: TaskStatusEnum.EvalReturnedWPhysicianSignature,
                name: "Returned W/ Physician Signature"
            }
        ],
        [
            "EvalSentToPhysicianElectronically",
            {
                value: TaskStatusEnum.EvalSentToPhysicianElectronically,
                name: "Sent To Physician (Electronically)"
            }
        ],
        [
            "NoteReturnedForClinicianSignature",
            {
                value: TaskStatusEnum.NoteReturnedForClinicianSignature,
                name: "Returned for Clinician Signature"
            }
        ],
        [
            "EvalReturnedByPhysician",
            {
                value: TaskStatusEnum.EvalReturnedByPhysician,
                name: "Returned for Review by Physician"
            }
        ],
        [
            "NoteSavedFromMobile",
            {
                value: TaskStatusEnum.NoteSavedFromMobile,
                name: "Saved From Mobile Device"
            }
        ],
        [
            "NoteCompletedFromMobile",
            {
                value: TaskStatusEnum.NoteCompletedFromMobile,
                name: "Completed From Mobile Device"
            }
        ],
        [
            "NoteSubmittedFromMobile",
            {
                value: TaskStatusEnum.NoteSubmittedFromMobile,
                name: "Submitted From Mobile Device"
            }
        ]
    ]);
}

export const HCTaskStatus = new HCTaskStatusEnumClass();
export const HHTaskStatus = new HHTaskStatusEnumClass();
